import React from 'react';

export default {
  joinTitle:
   'Join the Dyzio Influencer Network today',

  joinDescription: (
    <span>
         We offer you the opportunity to collaborate with global brands, on new and exciting briefs.
      <br />
         We just ask that you sign-in with instagram, so we can verify who you are!
    </span>
  ),

  featureList: (
    <div>
      <h4>Get paid to produce content for the brands you love:</h4>
      <ul>
        <li>Sign-up to our exclusive influencer network and receive briefs direct from the Dyzio team</li>
        <li>Get a free media kit and personal page (coming soon)</li>
        <li>Create your own campaigns and reports (coming soon)</li>
        <li>You choose the campaigns that you want to work on</li>
        <li>We believe influencers should create and be creative</li>
      </ul>
    </div>
  ),

  applicationFormInstructions: (
    <div>
      <p>Please fill in this short form to complete your application.</p>
      <br />
      <p>
        The Dyzio Influencer Network is free to join,
         no contracts and your data is not shared without your permission
      </p>
      <br />
      <p>
        All influencer accounts are manually checked
         by our team before gaining access to the platform, we’ll be in touch soon.
      </p>
    </div>
  ),
};



/** WEBPACK FOOTER **
 ** ./src/themes/default-copy.js
 **/